import {cart2sphere, sphere2equi, inside} from './mathematics';
import ProtobufCommonService from 'a_common-folder/services/protobuf.service';

export default class TexturesService {
    constructor(resolutionScale, qualityScale){
        this._resolutionScale = resolutionScale;
        this.qualityScale = qualityScale;

        this._createCanvasElementBuffer();
        this._createCanvasElementPreview();
    }

    static parseTextures(ignoreParse, planConfig, ignorProgress = false) {
        if(ignoreParse) return Promise.resolve(true);

        return new Promise((res, rej) => {
            let {textures} = planConfig;
            if(!textures) return Promise.reject(true);

            const link = textures.match(/(\/e3textures.*)\w+/)[0];
            const parseCallback = ignorProgress ? null : (e) => TexturesService.sendProgress({loaded: e.loaded,  total: e.total, link});
            const getTextureCallback = ignorProgress ? null : (loaded, total) => TexturesService.sendProgress({loaded, total, link: null});

            this._protobufService = new ProtobufCommonService('e3.Textures');
            this._protobufService.parseDat(link, parseCallback)
                .then((result) => {
                    Spritesmith.getTextures(result, getTextureCallback).then((data) => {
                        TexturesService.updateTextureData(data, planConfig);
                        res(false);
                    });
                })
        })
    }

    static sendProgress({loaded, total, link}){
        window.postMessage({
            event: 'parseTexture',
            loaded: loaded,
            total: total,
            url: link
        }, '*');
    }

    static updateTextureData(textures, planConfig){
        let {layers} = planConfig;
        for(var id in layers){
            for(var lineId in layers[id].lines){
                textures.forEach(function (texture) {
                    if(layers[id].lines[lineId].id == texture.id){
                        layers[id].lines[lineId].texture = texture.src;
                    }
                })
            }
            for(var areaId in layers[id].areas){
                textures.forEach(function (texture) {
                    if(layers[id].areas[areaId].id == texture.id && texture.type == 'floor'){
                        if(layers[id].areas[areaId].texture == null && typeof layers[id].areas[areaId].texture !== "object") layers[id].areas[areaId].texture = {};
                        layers[id].areas[areaId].texture['floor'] = texture.src;
                    }else if(layers[id].areas[areaId].id == texture.id && texture.type == 'ceiling'){
                        if(layers[id].areas[areaId].texture == null || typeof layers[id].areas[areaId].texture !== "object") layers[id].areas[areaId].texture = {};
                        layers[id].areas[areaId].texture['ceiling'] = texture.src;
                    }
                })
            }
        }
    }

    loadPanorama(panorama, obj) {
        // return new Promise((res, rej) => {
        //     this._loadPanorama(panorama).then((img) => {
        //         this._img = img;
        //         res(img);
        //         this._drawPanorama(img);
        //     });
        // })
        return this._loadPanorama(panorama, undefined,  obj)
            .then((img) => {
                this._img = img;
                this._drawPanorama(img);

                return img;
            })
    }

    splitTexture(coordCart, id, celling, type = 'wall', flipX = false, {poseRoll, posePitch}) {
        posePitch *= -1;
        poseRoll *= -1;

        const posePitchCos = Math.cos(posePitch);
        const posePitchSin = Math.sin(posePitch);
        const poseRollCos = Math.cos(poseRoll);
        const poseRollSin = Math.sin(poseRoll);
        return new Promise((res, rej) => {
            if(type === 'wall'){
                let promiseTextures = [];
                coordCart.reduce((previousValue, currentValue, index) => {
                    promiseTextures.push(this._getTextureFromWall(previousValue.bottom,  currentValue.bottom, currentValue.top, previousValue.top, id, celling, flipX, {posePitchCos, posePitchSin, poseRollCos, poseRollSin}));
                    return currentValue;
                });

                Promise.all(promiseTextures).then((data) => {
                    res(data[0]);
                })
            }else{
                this._getTextureFromFloor(coordCart, id, {posePitchCos, posePitchSin, poseRollCos, poseRollSin}).then((data) => {
                    res(data);
                });
            }
        })
    }

    _drawPanorama(img) {
        // Math.round is used because of Safari issue for CanvasRenderingContext2D.drawImage method,
        // it accepts only integer (not float) values
        let width = Math.round(img.width * this._resolutionScale);
        let height = Math.round(img.height * this._resolutionScale);
        this._buffer.width = width;
        this._buffer.height = height;

        // rotate the canvas to the specified degrees
        this._bctx.drawImage(img,  0, 0, width, height);
        this._bufferImgData = this._bctx.getImageData(0, 0, width, height).data;
    }

    _getTextureFromFloor(points, areaID, {posePitchCos, posePitchSin, poseRollCos, poseRollSin}) {
        return new Promise((res, rej) => {
            let yaw, pitch;
            let maxsy = 0;
            let maxsx = 0;
            let minsy = 0;
            let minsx = 0;
            for(let i = 0; i < points.length; i++) {
                let [yaw, pitch] = cart2sphere(points[i].x, points[i].y, points[i].z, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
                let [sx, sy] = sphere2equi(yaw, pitch, this._buffer.width, this._buffer.height, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});

                if(sy > maxsy) {
                    maxsy = sy;
                }
                if(sx > maxsx) {
                    maxsx = sx;
                }
                if(sy < minsy) {
                    minsy = sy;
                }
                if(sx < minsx) {
                    minsx = sx;
                }
            }

            let minx = 9999999999999999;
            let maxx = 0;
            let miny = 9999999999999999;
            let maxy = 0;

            if(points.length) {
                for(let i = 0; i < points.length; i++) {
                    if(points[i].x < minx) {
                        minx = points[i].x;
                    }

                    if(points[i].x > maxx) {
                        maxx = points[i].x;
                    }

                    if(points[i].y < miny) {
                        miny = points[i].y;
                    }

                    if(points[i].y > maxy) {
                        maxy = points[i].y;
                    }
                }
            }

            this._preview.width = maxsy / this.qualityScale;
            const ratio = (maxy-miny)/(maxx-minx);
            // this._preview.height = this._buffer.width;
            this._preview.height = maxsy * ratio / this.qualityScale;

            this._previewImgData = this._pctx.createImageData(this._preview.width, this._preview.height);
            let spx, spy;
            for(let y=0; y <= this._preview.height; y++){
                for(let x=0; x <= this._preview.width; x++){
                    let px = minx + x * ((maxx - minx) / this._preview.width);
                    let py = miny + y * ((maxy - miny) / this._preview.height);
                    let pz = points[0].z;

                    // if(inside(px, py, points)) {
                        [px, py, pz] = this._correction(px, py, pz, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});

                        [yaw, pitch] = cart2sphere(px, py, pz, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
                        [spx, spy] = sphere2equi(yaw, pitch, this._buffer.width, this._buffer.height, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});

                        let source = ((spy >>> 0) * this._buffer.width + (spx >>> 0)) * 4;
                        let dest = (y * this._preview.width + x) * 4;

                        this._previewImgData.data[dest]       = this._bufferImgData[source];
                        this._previewImgData.data[dest+1]     = this._bufferImgData[source+1];
                        this._previewImgData.data[dest+2]     = this._bufferImgData[source+2];
                        this._previewImgData.data[dest+3]     = this._bufferImgData[source+3];
                    // }
                }
            }

            let bbcanvas = document.createElement('canvas');
            let bbctx = bbcanvas.getContext('2d');

            bbcanvas.width = this._preview.width;
            bbcanvas.height = this._preview.height;

            this._preview.width = bbcanvas.height;
            this._preview.height = bbcanvas.width;

            bbctx.putImageData(this._previewImgData, 0, 0);

            this._pctx.scale(-1, 1);
            this._pctx.rotate(Math.PI/2);
            this._pctx.drawImage(bbcanvas, 0, 0);

            bbctx.clearRect(0, 0, bbcanvas.width, bbcanvas.height);
            bbcanvas = null;

            res({id: areaID, src: this._preview.toDataURL('image/jpeg', 0.75)});
        })
    }

    _getTextureFromWall(floorL, floorR, ceelingR, ceelingL, lineId, celling, flipX, {posePitchCos, posePitchSin, poseRollCos, poseRollSin}) {
        return new Promise((res, rej) => {
            let stepd;
            let yaw, pitch;
            //floor
            [yaw, pitch] = cart2sphere(floorL.x, floorL.y, floorL.z, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
            let [sx1, sy1] = sphere2equi(yaw, pitch, this._buffer.width, this._buffer.height, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});

            [yaw, pitch] = cart2sphere(floorR.x, floorR.y, floorR.z, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
            let [sx2, sy2] = sphere2equi(yaw, pitch, this._buffer.width, this._buffer.height, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
            // ceeling
            [yaw, pitch] = cart2sphere(ceelingR.x, ceelingR.y, ceelingR.z, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
            let [sx3, sy3] = sphere2equi(yaw, pitch, this._buffer.width, this._buffer.height, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});

            [yaw, pitch] = cart2sphere(ceelingL.x, ceelingL.y, ceelingL.z, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
            let [sx4, sy4] = sphere2equi(yaw, pitch, this._buffer.width, this._buffer.height, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});

            let h1 = sy1 - sy3;
            let h2 = sy2 - sy4;

            if(h1 > h2) {
                this._preview.height = h1 / this.qualityScale;
            } else {
                this._preview.height = h2 / this.qualityScale;
            }

            let stepz = celling / this._preview.height;

            if(floorR.x > floorL.x) {
                stepd = stepz;
            } else {
                stepd = -stepz;
            }

            let dx = (floorR.x - floorL.x);
            let dy = (floorR.y - floorL.y);
            let alpha = Math.atan(dy / dx);
            let length = Math.sqrt(dx * dx + dy * dy);

            // prevent from wrong scaling in case of mini floorplan
            this._preview.width = Math.abs(parseInt(length / stepd)) || 10;

            this._previewImgData = this._pctx.createImageData(this._preview.width, this._preview.height);

            let sx, sy,
                bufferWidth = this._buffer.width,
                bufferHeight = this._buffer.height,
                previewWidth = this._preview.width;

            for(let y=0; y <= this._preview.height; y++){
                for(let x=0; x <= this._preview.width; x++){
                    let pd = x * stepd;
                    let px = floorL.x + pd * Math.cos(alpha);
                    let py = floorL.y + pd * Math.sin(alpha);
                    let pz = floorL.z + celling - stepz * y;

                    [px, py, pz] = this._correction(px, py, pz, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
                    [yaw, pitch] = cart2sphere(px, py, pz, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});
                    [sx, sy] = sphere2equi(yaw, pitch, bufferWidth, bufferHeight, {posePitchCos, posePitchSin, poseRollCos, poseRollSin});

                    let source = ((sy >>> 0) * bufferWidth + (sx >>> 0)) * 4;
                    let dest = (y * previewWidth + x) * 4;

                    this._previewImgData.data[dest]       = this._bufferImgData[source];
                    this._previewImgData.data[dest+1]     = this._bufferImgData[source+1];
                    this._previewImgData.data[dest+2]     = this._bufferImgData[source+2];
                    this._previewImgData.data[dest+3]     = this._bufferImgData[source+3];
                }
            }

            if(flipX){
                this._flipX();
            }else{
                this._pctx.putImageData(this._previewImgData, 0, 0);
            }

            res({id: lineId, src: this._preview.toDataURL('image/jpeg', 0.75)});
        })
    }

    _correction(px, py, pz, {posePitchCos, posePitchSin, poseRollCos, poseRollSin}) {
        let ox = px * poseRollCos + pz * poseRollSin;
        let oy = py * posePitchCos + posePitchSin * (px * poseRollSin - pz * poseRollCos);
        pz = py * posePitchSin - posePitchCos * (px * poseRollSin - pz * poseRollCos);
        px = ox;
        py = oy;

        return [px, py, pz];
    }

    _flipX() {
        let bbcanvas = document.createElement('canvas');
        let bbctx = bbcanvas.getContext('2d');

        bbcanvas.width = this._preview.width;
        bbcanvas.height = this._preview.height;

        bbctx.putImageData(this._previewImgData, 0, 0);
        this._pctx.translate(this._preview.width, 0);
        this._pctx.scale(-1, 1);
        this._pctx.drawImage(bbcanvas, 0, 0);

        bbctx.clearRect(0, 0, bbcanvas.width, bbcanvas.height);
        bbcanvas = null;
    }

    _loadPanorama(src, owner, obj) {
        return new Promise(function (res, rej) {
            let retries = 0;
            let img = new Image;
            img.crossOrigin = 'anonymous';
            function load () {
                var xhr = new XMLHttpRequest();

                xhr.open('GET', src, true);
                xhr.responseType = 'arraybuffer';

                xhr.addEventListener('load', (e) => {
                    console.log('loadPanorama', obj.name)
                    window.postMessage({
                        name: obj.name,
                        event: 'loadPanorama',
                        loaded: obj.loaded,
                        total: obj.total,
                        url: src
                    }, '*');
                    img.src = window.URL.createObjectURL(new Blob([xhr.response]));
                });

                xhr.addEventListener('error', (e) => {
                    console.log('detected error');

                    if (retries < 3) {
                        window.setTimeout(() => {
                            console.log('timed retry');

                            retries++;

                            load();
                        }, 2000);
                    } else {
                        window.postMessage({event: 'loadPanoramaFailed'});
                    }
                });

                xhr.addEventListener('progress', (e) => {
                    if (owner && owner._interuptTexturesProcessing) {
                        xhr.abort();
                    }
                });

                xhr.send();
            }

            img.addEventListener('load', () => { res(img); }, false);

            load();
        }.bind(this))
    }

    _createCanvasElementBuffer() {
        this._buffer = document.createElement('canvas');
        this._bctx = this._buffer.getContext('2d');
    }

    _createCanvasElementPreview() {
        this._preview = document.createElement('canvas');
        this._preview.id = 'preview'
        this._pctx = this._preview.getContext('2d');
    }

    destroy(){
        this._pctx.clearRect(0, 0, this._preview.width, this._preview.height);
        this._bctx.clearRect(0, 0, this._buffer.width, this._buffer.height);
        this._preview = null;
        this._pctx = null;
        this._buffer = null;
        this._bctx = null;
        this._previewImgData = null;
    }
}
